import { iconsSet } from '@/assets/icons/icons.js';

// Export individual constants as needed

// Resource Content Types
export const RESOURCE_CONTENT_TYPE_FILE = 'F';
export const RESOURCE_CONTENT_TYPE_LINK = 'L';

// Resource Content Type Labels
export const RESOURCE_CONTENT_TYPE_LABELS = {
    [RESOURCE_CONTENT_TYPE_LINK]: 'Link',
    [RESOURCE_CONTENT_TYPE_FILE]: 'File',
};


// Cart Types
export const CART_TYPE_REGULAR = 'regular';
export const CART_TYPE_STORE = 'store';
export const CART_TYPE_LABEL = 'printLabel';
export const CART_TYPE_CLAIM = 'claim';
export const CART_TYPE_SAVED = 'savedItems';
export const CART_TYPE_QUICK = 'quick';
export const CART_TYPE_CLAIM_CONFIRMATION = 'claimConfirmation';
export const CART_TYPE_CONFIRMATION = 'confirmation';

// Claim Cart Quantity Types
export const CLAIM_CART_QUANTITY_TYPE_CLAIM = 'Claim';
export const CLAIM_CART_QUANTITY_TYPE_RETURN = 'Return';

// Claim Quantity Types (lowercase)
export const CLAIM_QUANTITY_TYPE_CLAIM_LOWER = 'claim';
export const CLAIM_QUANTITY_TYPE_RETURN_LOWER = 'return';

// Claim Cart Reason Codes
export const CLAIM_REASON_CODE_OUT_OF_DATE = '10';

// Return Order Code
export const ORDER_TYPE_RETURN = 'RO';


// HTTP Codes
export const HTTP_OK = 200;
export const HTTP_CREATED = 201;

export const HTTP_BAD_REQUEST = 400;
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_NOT_ALLOWED = 405;
export const HTTP_UNPROCESSABLE_CONTENT = 422;
export const HTTP_TOO_MANY_ATTEMPTS = 429;

export const HTTP_INTERNAL_SERVER_ERROR = 500;
export const HTTP_NOT_IMPLEMENTED = 501;

export const HTTP_STATUS_CODES = {
    'OK': HTTP_OK,
    'CREATED': HTTP_CREATED,
    'BAD_REQUEST': HTTP_BAD_REQUEST,
    'UNAUTHORIZED': HTTP_UNAUTHORIZED,
    'FORBIDDEN': HTTP_FORBIDDEN,
    'NOT_FOUND': HTTP_NOT_FOUND,
    'NOT_ALLOWED': HTTP_NOT_ALLOWED,
    'UNPROCESSABLE_CONTENT': HTTP_UNPROCESSABLE_CONTENT,
    'TOO_MANY_ATTEMPTS': HTTP_TOO_MANY_ATTEMPTS,
    'INTERNAL_SERVER_ERROR': HTTP_INTERNAL_SERVER_ERROR,
    'NOT_IMPLEMENTED': HTTP_NOT_IMPLEMENTED
};


// Status Codes
export const STATUS_SUCCESS = 'success';
export const STATUS_PARTIAL = 'partial';
export const STATUS_ERROR = 'error';
export const STATUS_PENDING = 'Pending';


// Form Types
export const FORM_TYPE_ADD = 'Add';
export const FORM_TYPE_EDIT = 'Edit';
export const FORM_TYPE_DISPLAY = 'Display';


// User Status Codes
export const USER_STATUS_ACTIVE = 'A';
export const USER_STATUS_DISABLED = 'D';


// Special Field Authorities for UserForm Component
// Authority fields to disable for unauthorized users on the edit user page
export const SPECIAL_AUTH_EDIT_FIELDS = [
    'authPrintLabels',
    'authAllPromotions',
    'authPlaceFutureOrders',
    'authSeePurchaseReports',
];
// Authority fields to disable for unauthorized users on the add user page
export const SPECIAL_AUTH_ADD_FIELDS = [
    'authPrintLabels',
    'authAllPromotions',
    'authTopSellersInquiry',
    'authPlaceFutureOrders',
    'authSeePurchaseReports',
];
// Authority fields only available for Unipharm users
export const UNIPHARM_USER_ONLY_FIELDS = [
    'isSuperAdmin', 
    'isUnipharmAdmin', 
    'isResourceAdmin'
];
// Authority fields not available to Unipharm users
export const UNIPHARM_USER_DENIED_FIELDS = [
    'authPlaceOrders', 
    'authPlaceFutureOrders', 
    'authSubmitClaims'
];


// Authority Fields Used in Ordering Process
export const AUTHORITY_IS_PHARMACIST = 'IsPharmacist';
export const AUTHORITY_PLACE_ORDERS = 'PlaceOrders';
export const AUTHORITY_REGULAR_CART= 'RegularCart';
export const AUTHORITY_STORE_CART = 'StoreCart';
export const AUTHORITY_CLAIM_CART = 'SubmitClaims';
export const AUTHORITY_PLACE_FUTURE_ORDERS = 'PlaceFutureOrders';
export const AUTHORITY_ALL_PRICING = 'AllPricing';
export const AUTHORITY_SEE_ONLY_SRP_PRICING = 'OnlySrpPricing';
export const AUTHORITY_MAINTAIN_SRPS = 'MaintainSrps';


// Button Types and Display Types for ActionButton Component
export const BUTTON_TYPE_PRIMARY = 'primary';
export const BUTTON_TYPE_SECONDARY = 'secondary';

export const BUTTON_DISPLAY_TYPE_FIVE_SEVEN_RATIO = 'fiveSevenRatio';

// Button CSS Classes
export const BUTTON_CLASS_FULL_WIDTH_NO_MARGIN = 'w-100 mt-0';

// Filter Types
export const FILTER_TYPE_CLASS = 'Class';
export const FILTER_TYPE_VENDOR = 'Vendor';
export const FILTER_TYPE_ITEM = 'Item';
export const FILTER_TYPE_ITEM_NUM = 'itemNumber';
export const FILTER_TYPE_UPC = 'upc';
export const FILTER_TYPE_NPN = 'npn';
export const FILTER_TYPE_DIN = 'din';
export const FILTER_TYPE_VENDOR_ITEM = 'vendorItemNum';
export const FILTER_TYPE_DESCRIPTION = 'description';
export const FILTER_TYPE_UNIPHARM_ITEM_GROUP = 'unipharmItemGroup';
export const FILTER_TYPE_INVOICE = 'invoice';

// Invoice Constants
export const INVOICE_NUMBER_LENGTH = 7;

export const FILTER_TYPES = {
    'CLASS': FILTER_TYPE_CLASS,
    'VENDOR': FILTER_TYPE_VENDOR,
    'ITEM': FILTER_TYPE_ITEM,
    'ITEM_NUM': FILTER_TYPE_ITEM_NUM,
    'UPC': FILTER_TYPE_UPC,
    'NPN': FILTER_TYPE_NPN,
    'DIN': FILTER_TYPE_DIN,
    'VENDOR_ITEM': FILTER_TYPE_VENDOR_ITEM,
    'DESCRIPTION': FILTER_TYPE_DESCRIPTION,
    'UNIPHARM_ITEM_GROUP': FILTER_TYPE_UNIPHARM_ITEM_GROUP,
    'INVOICE': FILTER_TYPE_INVOICE,
};


// Statement Types
export const STATEMENT_TYPE_AR = 'ar';
export const STATEMENT_TYPE_SALES_TAX = 'tax';
export const STATEMENT_TYPE_CUSTOMER_POS = 'pos';


// Print Label Types
export const LABEL_TYPE_PRICE_TICKET = 'priceTicket';
export const LABEL_TYPE_SHELF_LABEL = 'shelfLabel';


// Catalog Types
export const CATALOG_TYPE_REGULAR = 'regularCatalog';
export const CATALOG_TYPE_ITEM_SEARCH = 'itemSearch';
export const CATALOG_TYPE_NEW_ITEMS = 'newItemsCatalog';
export const CATALOG_TYPE_CHANGED_ITEMS = 'changedItems';
export const CATALOG_TYPE_ALTERNATE_ITEMS = 'alternateItems';


// Duplication Statuses for Carts
export const DUPLICATION_STATUS_DUPLICATED = 'Has duplicates';
export const DUPLICATION_STATUS_DUPLICATE = 'Duplicate item';


// Surcharge Types
export const SURCHARGE_TYPE_PIECES = 'Pcs';
export const SURCHARGE_TYPE_FIXED = 'UnitSpecific';


// Manage User Pages
export const PAGE_SITE_ADMIN_MANAGE_USERS = 'Manage Users';
export const PAGE_SUPER_ADMIN_MANAGE_USERS = 'Manage All Users';


// Number of pages to show on pagination
export const PAGINATION_LIMIT = 7;


// Customer Groups eligible to place future orders
export const FUTURE_ORDER_CUSTOMER_GROUPS = ["SH", "AM", "STAFF"];


// Cart Validation Statuses
export const CART_LINE_STATUS_CANCELLED = 'Item Cancelled';
export const CART_LINE_STATUS_SUBSTITUTED = 'Item Substituted';
export const CART_LINE_STATUS_ADJUSTED = 'Item Adjusted';
export const CART_LINE_STATUS_OPEN = 'No Adjustments';

// Validation Messages for Cart Adjustments
export const CART_ADJUSTMENTS_VALIDATION_MESSAGES = {
    [CART_LINE_STATUS_SUBSTITUTED]: 'Item Substituted',
    [CART_LINE_STATUS_ADJUSTED]: 'Quantity Adjusted',
    [CART_LINE_STATUS_CANCELLED]: 'Item Cancelled',
    [CART_LINE_STATUS_OPEN]: 'No adjustments required.',
};


// Cart Adjustments Valid Time
export const CART_ADJUSTMENTS_VALID_TIME = 3 * 60 * 1000; // 3 minutes in milliseconds


// Item Statuses
export const ITEM_ACTIVE = 'active';
export const ITEM_INACTIVE = 'inactive';


// Default icons
export const DEFAULT_ICONS = {
    'ADD': iconsSet.cilPlus,
    'ARCHIVE': iconsSet.cilHistory,
    'BACK': iconsSet.cilChevronLeft,
    'BACK_TO_TOP': iconsSet.cilChevronCircleUpAlt,
    'CART': iconsSet.cilCart,
    'CHECKMARK': iconsSet.cilCheck,
    'CLEAR': iconsSet.cilX,
    'CLOSE': iconsSet.cilX,
    'CONFIRM': iconsSet.cilTask,
    'CONSOLIDATE': iconsSet.cilVerticalAlignCenter,
    'DELETE': iconsSet.cilTrash,
    'DETAILS': iconsSet.cilFindInPage,
    'DISPUTED': iconsSet.cilBan,
    'DOWNLOAD': iconsSet.cilVerticalAlignBottom,
    'EDIT': iconsSet.cilPencil,
    'EMAIL': iconsSet.cilEnvelopeClosed,
    'FILE': iconsSet.cilDescription,
    'FOLDER_CLOSED': iconsSet.cilFolder,
    'FOLDER_OPEN': iconsSet.cilFolderOpen,
    'INVALID': iconsSet.cilXCircle,
    'INVOICE': iconsSet.cilDescription,
    'ITEM_ALTERNATIVES': iconsSet.cilTransfer,
    'ITEM_IMAGE': iconsSet.cilCamera,
    'LINE_TEXT': iconsSet.cilSpeech,
    'LIST_ORDER': iconsSet.cilListHighPriority,
    'LINK': iconsSet.cilLink,
    'LOCK': iconsSet.cilHttps,
    'LOG_OUT': iconsSet.cilAccountLogout,
    'MENU': iconsSet.cilHamburgerMenu,
    'MINUS': iconsSet.cilMinus,
    'NOTIFICATION': iconsSet.cilBell,
    'ORDER': iconsSet.cilTruck,
    'ORDER_CONFIRMATION': iconsSet.cilNotes,
    'PLUS': iconsSet.cilPlus,
    'PRINT': iconsSet.cilPrint,
    'PRINT_LABEL_QUEUE': iconsSet.cilList,
    'REFRESH': iconsSet.cilReload,
    'RESET': iconsSet.cilSync,
    'SAVE': iconsSet.cilSave,
    'SEARCH': iconsSet.cilSearch,
    'SORT': iconsSet.cilSwapVertical,
    'SORT_ASC': iconsSet.cilArrowBottom,
    'SORT_DESC': iconsSet.cilArrowTop,
    'SRP': iconsSet.cilTag,
    'STAR': iconsSet.cilStar,
    'SUBMIT': iconsSet.cilSend,
    'UPLOAD': iconsSet.cilCloudUpload,
    'USER': iconsSet.cilUser,
    'VALID': iconsSet.cilCheckCircle,
    'WARNING': iconsSet.cilWarning,
    'ZOOM_IN': iconsSet.cilZoomIn,
    'ZOOM_OUT': iconsSet.cilZoomOut,
    'FONT_AWESOME': {
        'ADMIN_USER': 'fa-regular fa-id-badge',
        'CARET_DOWN': 'caret-down',
        'CARET_UP': 'caret-up',
        'EYE': 'fa-regular fa-eye',
        'EYE_SLASH': 'fa-regular fa-eye-slash',
        'KEY': 'key',
        'NARCOTIC': 'prescription-bottle-medical',
        'PENDING': 'fa-regular fa-hourglass-half',
        'PRIORITY': 'star',
        'REVIEW_CART': 'fa-clipboard-check',
        'REVIEW_LIST': 'fa-list-check',
        'SIGN_FILE': 'file-signature',
        'TOOL_TIP': 'fa-regular fa-circle-question',
    },
};


// Navbar constants
export const NAVBAR_TYPE_DESKTOP = 'desktop';
export const NAVBAR_TYPE_MOBILE = 'mobile';

export const NAVBAR_ITEM_TYPE_DROPDOWN = 'dropdown';
export const NAVBAR_ITEM_TYPE_LINK = 'link';

export const NAVBAR_LINK_TYPE_POPUP = 'popup';


// Page title
export const PAGE_TITLE = 'Unipharm Web Orders'


// Export all constants as an object
export default {
    RESOURCE_CONTENT_TYPE_FILE,
    RESOURCE_CONTENT_TYPE_LINK,
    RESOURCE_CONTENT_TYPE_LABELS,
    CART_TYPE_REGULAR,
    CART_TYPE_STORE,
    CART_TYPE_LABEL,
    CART_TYPE_CLAIM,
    CART_TYPE_CONFIRMATION,
    CART_TYPE_CLAIM_CONFIRMATION,
    CART_TYPE_SAVED,
    CART_TYPE_QUICK,
    CLAIM_CART_QUANTITY_TYPE_CLAIM,
    CLAIM_CART_QUANTITY_TYPE_RETURN,
    CLAIM_QUANTITY_TYPE_CLAIM_LOWER,
    CLAIM_QUANTITY_TYPE_RETURN_LOWER,
    ORDER_TYPE_RETURN,
    CLAIM_REASON_CODE_OUT_OF_DATE,
    HTTP_OK,
    HTTP_CREATED,
    HTTP_BAD_REQUEST,
    HTTP_UNAUTHORIZED,
    HTTP_FORBIDDEN,
    HTTP_NOT_FOUND,
    HTTP_NOT_ALLOWED,
    HTTP_UNPROCESSABLE_CONTENT,
    HTTP_TOO_MANY_ATTEMPTS,
    HTTP_INTERNAL_SERVER_ERROR,
    HTTP_NOT_IMPLEMENTED,
    HTTP_STATUS_CODES,
    STATUS_SUCCESS,
    STATUS_PARTIAL,
    STATUS_ERROR,
    STATUS_PENDING,
    FORM_TYPE_ADD,
    FORM_TYPE_EDIT,
    FORM_TYPE_DISPLAY,
    USER_STATUS_ACTIVE,
    USER_STATUS_DISABLED,
    SPECIAL_AUTH_EDIT_FIELDS,
    SPECIAL_AUTH_ADD_FIELDS,
    UNIPHARM_USER_ONLY_FIELDS,
    UNIPHARM_USER_DENIED_FIELDS,
    AUTHORITY_IS_PHARMACIST,
    AUTHORITY_PLACE_ORDERS,
    AUTHORITY_REGULAR_CART,
    AUTHORITY_STORE_CART,
    AUTHORITY_CLAIM_CART,
    AUTHORITY_PLACE_FUTURE_ORDERS,
    AUTHORITY_ALL_PRICING,
    AUTHORITY_SEE_ONLY_SRP_PRICING,
    AUTHORITY_MAINTAIN_SRPS,
    BUTTON_TYPE_PRIMARY,
    BUTTON_TYPE_SECONDARY,
    BUTTON_DISPLAY_TYPE_FIVE_SEVEN_RATIO,
    BUTTON_CLASS_FULL_WIDTH_NO_MARGIN,
    FILTER_TYPE_CLASS,
    FILTER_TYPE_VENDOR,
    FILTER_TYPE_ITEM,
    FILTER_TYPE_ITEM_NUM,
    FILTER_TYPE_UPC,
    FILTER_TYPE_NPN,
    FILTER_TYPE_DIN,
    FILTER_TYPE_VENDOR_ITEM,
    FILTER_TYPE_DESCRIPTION,
    FILTER_TYPE_UNIPHARM_ITEM_GROUP,
    FILTER_TYPE_INVOICE,
    INVOICE_NUMBER_LENGTH,
    FILTER_TYPES,
    STATEMENT_TYPE_AR,
    STATEMENT_TYPE_SALES_TAX,
    STATEMENT_TYPE_CUSTOMER_POS,
    LABEL_TYPE_PRICE_TICKET,
    LABEL_TYPE_SHELF_LABEL,
    CATALOG_TYPE_REGULAR,
    CATALOG_TYPE_ITEM_SEARCH,
    CATALOG_TYPE_NEW_ITEMS,
    CATALOG_TYPE_CHANGED_ITEMS,
    CATALOG_TYPE_ALTERNATE_ITEMS,
    DUPLICATION_STATUS_DUPLICATED,
    DUPLICATION_STATUS_DUPLICATE,
    SURCHARGE_TYPE_PIECES,
    SURCHARGE_TYPE_FIXED,
    PAGE_SITE_ADMIN_MANAGE_USERS,
    PAGE_SUPER_ADMIN_MANAGE_USERS,
    PAGINATION_LIMIT,
    FUTURE_ORDER_CUSTOMER_GROUPS,
    CART_LINE_STATUS_CANCELLED,
    CART_LINE_STATUS_SUBSTITUTED,
    CART_LINE_STATUS_ADJUSTED,
    CART_LINE_STATUS_OPEN,
    CART_ADJUSTMENTS_VALIDATION_MESSAGES,
    CART_ADJUSTMENTS_VALID_TIME,
    ITEM_ACTIVE,
    ITEM_INACTIVE,
    DEFAULT_ICONS,
    NAVBAR_TYPE_DESKTOP,
    NAVBAR_TYPE_MOBILE,
    NAVBAR_ITEM_TYPE_DROPDOWN,
    NAVBAR_ITEM_TYPE_LINK,
    NAVBAR_LINK_TYPE_POPUP,
    PAGE_TITLE,
};
